import { IApiError } from '@/models/apiError.model';
import { IDocumentsStepData, IPackageDocumentDTOes, IPropertyFile, ISelfDeclaration } from '@/models/documents.model';

export const DOCUMENTS_SLICE_NAME = 'documents';

export interface DocumentsState {
  isLoading: boolean;
  documentsStepData: IDocumentsStepData | null;
  propertyDocuments: IPackageDocumentDTOes | null;
  legalDocuments: IPropertyFile[] | null;
  selfDeclaration: ISelfDeclaration | null;
  files: IPropertyFile[] | null;
  error: IApiError | null;
}

export const initialState: DocumentsState = {
  documentsStepData: null,
  propertyDocuments: null,
  selfDeclaration: null,
  legalDocuments: null,
  files: null,
  isLoading: false,
  error: null,
};
